import React, { useState, useEffect, useRef, useCallback } from "react";
import { useToast } from "../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useSelector, useDispatch } from "react-redux";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { format, parse } from "date-fns";
import Tooltip from "../../Components/CustomToolTip/tooltip";
import {
  setInvestorId,
  setInvestorName,
  setCashReserve,
} from "../../Redux/store/investor";
import { svgLogoBase64 } from "../../Constants/config";

const InvestorList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const statusButtonRefs = useRef({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [totalCount, settotalCount] = useState(0);
  const [investortableData, setInvestortableData] = useState([]);
  const [showRecords, setShowRecords] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalInvestors, setTotalInvestors] = useState(0);
  const [totalInvestedAmount, setTotalInvestedAmount] = useState(0);
  const [filterText, setFilterText] = useState("created_at");
  const [investmentProductName, setinvestmentProductName] = useState("");
  const { from } = location.state || {};
  const investment_id = useSelector(
    (state) => state.portfolioInvestment.portfolioInvestmentId
  );
    const loggedInUserRole = useSelector((state) => state.user.roleName);
  
  const [showRecordsPortfolio, setShowRecordsPortfolio] = useState(10);
  const [currentPagePortfolio, setCurrentPagePortfolio] = useState(1);
  const [searchQueryPortfolio, setSearchQueryPortfolio] = useState("");
  const DateCalendarRef = useRef();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [quickFilter, setQuickFilter] = useState("");
  const [expandedRow, setExpandedRow] = useState(null);
  const [transactionTableData, setTransactionTableData] = useState(null);
  const [filter, setFilter] = useState("transaction");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [totalPagesPortfolio, setTotalPagesPortfolio] = useState(0);
  const [totalCountPortfolio, setTotalCountPortfolio] = useState(0);
  const DownloadRefPortfolio = useRef();
  const [isOpenDownloadReportPortfolio, setIsOpenDownloadReportPortfolio] =
    useState(false);
  const [pdfDataPortfolio, setPdfDataPortfolio] = useState([]);
  const [isHiddenTablePortfolio, setIsHiddenTablePortfolio] = useState(false); // Initially hidden
  const [isOpenDownloadReport, setIsOpenDownloadReport] = useState(false);
  const DownloadRef = useRef();
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden
  const [pdfData, setPdfData] = useState([]);

  const reportOptions = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const investorheaders = [
    { label: "Investor", key: "investor_name" },
    { label: "Strategy", key: "" },
    { label: "Cash Reserve", key: "cash_reserve" },
    { label: "Invested Amount", key: "invested_amount" },
  ];
  const headersDashboardPortfolio = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate (AUD)", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Running Balance", key: "" },
    { label: "Transaction Status", key: "" },
    { label: "", key: "" },
  ];
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const quickFilters = [
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "This Year", value: "this_year" },
    { label: "Last Year", value: "last_year" },
    { label: "Custom", value: "custom" },
    { label: "All Time", value: "" },
  ];
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [preSelectedFilterPortfolio, setpreSelectedFilterPortfolio] = useState({
    value: 10,
    label: "10",
  });
  const toggleRowDetails = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const handleSort = (key) => {
    setFilterText(key);
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key: null, direction });
  };
  function formatDateTransaction(inputDateString) {
    const cleanedDate = inputDateString.replace(/ [A-Z]{3,4}$/, ""); // Removes " AEDT"

    // Parse and format
    const parsedDate = parse(cleanedDate, "dd/MM/yyyy hh:mm:ss a", new Date());
    return format(parsedDate, "dd/MM/yyyy | HH:mm:ss");
  }
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAllDashboardPortfolioInvestors = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/dashboard/portfolio-management-account/${investment_id}/investors?page=${currentPage}&size=${showRecords}&search=${searchQuery}&sort_by=${filterText}&sort_order=${sortConfig.direction}`
      );
      if (response.status == 200) {
        if (response.data.data.length == 0) {
          setInvestortableData([]);
          setCurrentPage(1);
          settotalCount(0);
          settotalPages(0);
        } else {
          setInvestortableData(response.data.data);
          setinvestmentProductName(response.data.data[0].portfolio_name);
          setTotalInvestors(response.data.total_investors);
          setTotalInvestedAmount(response.data.total_invested_amount);
          setCurrentPage(response.data.page);
          settotalCount(response.data.total_count);
          settotalPages(response.data.total_pages);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setInvestortableData([]);
      }
    } catch (err) {
      showToast(err.message, "error");
      setInvestortableData([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };
  const handleshowRecordPortfolios = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsPortfolio(parseInt(selectedOption.value));
    setCurrentPagePortfolio(1);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        DownloadRefPortfolio.current &&
        !DownloadRefPortfolio.current.contains(event.target)
      ) {
        setIsOpenDownloadReportPortfolio(false);
      }
      if (DownloadRef.current && !DownloadRef.current.contains(event.target)) {
        setIsOpenDownloadReport(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  useEffect(() => {
    if (selectedDates.length === 2) {
      const formattedRange = `${formatDate(
        selectedDates[0].toLocaleDateString()
      )} — ${formatDate(selectedDates[1].toLocaleDateString())}`;
      setSelectedRange(formattedRange);
    }
  }, [selectedDates]);
  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;
    setCurrentPage(1);

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
  };
  const resetAllFilters = () => {
    setSelectedDates([]);
    setSelectedRange("Select Date Range");
    setQuickFilter("");
    setExpandedRow(null);
    setSearchQueryPortfolio("");
    setCurrentPagePortfolio(1);
    setShowRecordsPortfolio(10);
    setpreSelectedFilterPortfolio({ value: 10, label: "10" });
  };
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };
  const GetDashboardPortfolios = async () => {
    const token = localStorage.getItem("jwtToken");
    // const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl =loggedInUserRole=="advisor"?
       `${BASE_URL}/v1/advisor/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}&start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(
        selectedDates[1]
      )}&portfolio_id=${investment_id}`
      :
       `${BASE_URL}/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}&start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(
        selectedDates[1]
      )}&portfolio_id=${investment_id}`;
    } else {
      apiUrl =loggedInUserRole=="advisor"?`${BASE_URL}/v1/advisor/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}&portfolio_id=${investment_id}`
      : `${BASE_URL}/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}&portfolio_id=${investment_id}`;
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllPortfolioTransactions = async () => {
    setIsLoadingHistory(true);
    try {
      const response = await GetDashboardPortfolios();

      if (response.status == 200) {
        if (response.data == null) {
          setTransactionTableData([]);
          setTotalPagesPortfolio(0);
          setTotalCountPortfolio(0);
        } else {
          setTransactionTableData(response.data.transactions);
          setTotalPagesPortfolio(response.data.total_pages);
          setTotalCountPortfolio(response.data.total_count);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          setTransactionTableData([]);
          setTotalPagesPortfolio(0);
          setTotalCountPortfolio(0);
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setTransactionTableData([]);
      setTotalPagesPortfolio(0);
      setTotalCountPortfolio(0);
    } finally {
      setTimeout(function () {
        setIsLoadingHistory(false);
      }, 100);
    }
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = "";
      if (selectedDates.length == 2) {
        apiUrl = `/v1/transaction/portfolio-management/transactions/export/excel?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000&start_date=${formatDateForFilter(
          selectedDates[0]
        )}&end_date=${formatDateForFilter(
          selectedDates[1]
        )}&portfolio_id=${investment_id}`;
      } else {
        apiUrl = `/v1/transaction/portfolio-management/transactions/export/excel?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000&portfolio_id=${investment_id}`;
      }
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReport();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Transaction History-${investmentProductName}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
          setIsOpenDownloadReport(false);
          setIsOpenDownloadReport(false);
        } finally {
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          let apiUrl = "";
          if (selectedDates.length == 2) {
            apiUrl = `/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(
              selectedDates[1]
            )}&portfolio_id=${investment_id}`;
          } else {
            apiUrl = `/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000&portfolio_id=${investment_id}`;
          }
          const response = await GetAPIcalls(apiUrl);

          if (response.status == 200) {
            if (response.data == null) {
              setPdfData([]);
              setIsHiddenTable(false);
              setLoading(false);
              setIsOpenDownloadReport(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfData(response.data.transactions);
              setIsHiddenTable(true);
            }
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfData([]);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          setLoading(false);
          setIsOpenDownloadReport(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [
      selectedDates,
      currentPagePortfolio,
      searchQueryPortfolio,
      investment_id,
      investmentProductName,
    ] // Dependencies
  );
  const downloadExcelReportPortfolio = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = `/v1/dashboard/portfolio-management-account/${investment_id}/investors/export/excel?page=${currentPage}&size=1000&search=${searchQuery}&sort_by=${filterText}&sort_order=${sortConfig.direction}`;
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTablePortfolio = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReportPortfolio();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Portfolio Management Accounts-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
          setIsOpenDownloadReportPortfolio(false);
        } finally {
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          const response = await GetAPIcalls(
            `/v1/dashboard/portfolio-management-account/${investment_id}/investors?page=${currentPage}&size=1000&search=${searchQuery}&sort_by=${filterText}&sort_order=${sortConfig.direction}`
          );
          if (response.status == 200) {
            if (response.data.data.length == 0) {
              setPdfDataPortfolio([]);
              setIsHiddenTablePortfolio(false);
              setLoading(false);
              setIsOpenDownloadReportPortfolio(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfDataPortfolio(response.data.data);
              setIsHiddenTablePortfolio(true);
            }
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfDataPortfolio([]);
            setIsOpenDownloadReportPortfolio(false);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfDataPortfolio([]);
          setLoading(false);
          setIsOpenDownloadReportPortfolio(false);

          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [investment_id, currentPage, searchQuery, filterText, sortConfig] // Dependencies
  );

  function createTableBody(data, columns) {
    const body = document.createElement("tbody");

    data.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = columns
        .map(({ key, formatter }) => {
          let value = row[key];
          if (formatter) {
            value = formatter(value, row);
          }
          const styleAttr =
            key === "portfolio_name"
              ? 'style="width: 180px; white-space: normal; word-wrap: break-word; word-break: break-word;"'
              : "";

          return `<td >${value !== undefined ? value : ""}</td>`;
        })
        .join("");

      body.appendChild(tr);
    });

    return body;
  }
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  const handleDownloadPDFTablePortfolio = async () => {
    let headerDashboardFinal = [
      {
        label: "Investor",
        key: "investor_name",
      },
      {
        label: "Strategy",
        key: "portfolio_name",
        formatter: (val) => "Caprock Model portfolio - " + val,
      },
      {
        label: "Cash Reserve",
        key: "cash_reserve",
        formatter: (val) =>
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      {
        label: "Invested Amount",
        key: "invested_amount",
        formatter: (val) =>
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(
      pdfDataPortfolio,
      headerDashboardFinal
    );
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
                <!DOCTYPE html>
                <html>
                  <head>
                    <meta charset="utf-8" />
                    <style>
                    @page {
              size: A4 portrait;
              margin: 0;
            }
              html, body {
                      margin: 0;
                      padding: 0;
                                font-family:sans-serif;
              overflow: auto;  /* Ensure content can overflow */
            
                      height: 100%; /* Ensure the body fills the entire height */
                    }        .pdf-container {
                        max-width: 100% !important;
                        margin: 20px;
                      }
                      tr {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                      }
              
                      .custom-header {
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        background-color: #ffffff;
                        padding-top: 10px; /* Ensures no padding at the top */
                      }
              
                      .logo-container {
                        display: flex;
                        align-items: center;
                      }
              
                      .logo {
                        width: 96px; /* Tailwind w-24 = 6rem = 96px */
                        max-width: 150px;
                        height: auto;
                        object-fit: contain;
                        margin-right: 1rem;
                      }
              
                      .title {
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        font-size: 1rem; /* Tailwind text-lg */
                        font-weight: 500;    /* Tailwind font-medium */
                        padding: 0;          /* Remove any padding */
                        margin: 0;           /* Remove any margin */
                      }
              
                      .date {
                        font-size: 0.875rem;  /* Tailwind text-sm */
                        font-weight: 500;
                        color: #000000;
                        padding-bottom: 16px;
                      }
            
              
            .page-break {
                     page-break-before: always;
              break-before: page;
              display: block;
              height: 0; /* No extra space */
              width: 100%;
              content: "";}
                  table {
                  width: 100%;
                  border-collapse: collapse;
                  table-layout: auto;
                  margin-top: 10px;
                }
                  td:nth-child(1),
    th:nth-child(1) {
      width: 120px;
      white-space: normal;
      word-wrap: break-word;
      word-break: break-word;
    }
            
                thead {
                  font-size: 10px;
                  color: #6B7280; /* Tailwind text-labelColour equivalent */
                }
            
                th {
                  border-bottom: 1px solid #000;
                  padding: 8px;
                  text-align: left;
                }
                      td {
                  padding: 2px;
                  font-size: 10px;
                  vertical-align: middle;
                  text-align: left;
                }
                  .tbody-tr{
                              background-color: #F9F9F9;
                              margin-bottom: 10px;
            
                  }
                    </style>
                  </head>
                  <body>
                 <div class="pdf-container">
                    <div class="custom-header">
                      <div class="logo-container">
                        <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                      </div>
                      <h2 class="title">Investor List -${investmentProductName} </h2>
                      <div class="date">${date}</div>
                    </div>
                    
              <table id="dynamic-table">
              ${tableHeader}
                ${tableBody}
            
              </table>
                
                  </div> 
            
                       </body>
                </html>
              `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Investor List -${investmentProductName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTablePortfolio(false);
    setIsOpenDownloadReportPortfolio(false);
  };
  const handleDownloadPDFTable = async () => {
    let headerDashboardFinal = [
      {
        label: "Date & Time",
        key: "date",
        formatter: (val) => formatDateTransaction(val),
      },
      { label: "Transaction ID", key: "reference_code" },
      {
        label: "From Account",
        key: "account_name",
        formatter: (_, row) => {
          return row.from_account.name || "";
        },
      },
      {
        label: "To Account",
        key: "account_name",
        formatter: (_, row) => {
          return row.to_account.name || "";
        },
      },
      {
        label: "Convert Rate (AUD)",
        key: "convert_rate",
        formatter: (val) => val.toFixed(2),
      },
      {
        label: "Debit",
        key: "debit",
        formatter: (val) =>
          "$" +
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      {
        label: "Credit",
        key: "credit",
        formatter: (val) =>
          "$" +
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      {
        label: "Running Balance",
        key: "balance",
        formatter: (val) =>
          "$" +
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      { label: "Transaction Status", key: "status" },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
              <!DOCTYPE html>
              <html>
                <head>
                  <meta charset="utf-8" />
                  <style>
                  @page {
            size: A4 landscape;
            margin: 0;
          }
            html, body {
                    margin: 0;
                    padding: 0;
                              font-family:sans-serif;
            overflow: auto;  /* Ensure content can overflow */
          
                    height: 100%; /* Ensure the body fills the entire height */
                  }        .pdf-container {
                      max-width: 100% !important;
                      margin: 20px;
                    }
                    tr {
                      page-break-inside: avoid !important;
                      break-inside: avoid !important;
                    }
            
                    .custom-header {
                      position: relative;
                      display: flex;
                      justify-content: space-between;
                      background-color: #ffffff;
                      padding-top: 10px; /* Ensures no padding at the top */
                    }
            
                    .logo-container {
                      display: flex;
                      align-items: center;
                    }
            
                    .logo {
                      width: 96px; /* Tailwind w-24 = 6rem = 96px */
                      max-width: 150px;
                      height: auto;
                      object-fit: contain;
                      margin-right: 1rem;
                    }
            
                    .title {
                      position: absolute;
                      left: 50%;
                      transform: translateX(-50%);
                      font-size: 1.125rem; /* Tailwind text-lg */
                      font-weight: 500;    /* Tailwind font-medium */
                      padding: 0;          /* Remove any padding */
                      margin: 0;           /* Remove any margin */
                    }
            
                    .date {
                      font-size: 0.875rem;  /* Tailwind text-sm */
                      font-weight: 500;
                      color: #000000;
                      padding-bottom: 16px;
                    }
          
            
          .page-break {
                   page-break-before: always;
            break-before: page;
            display: block;
            height: 0; /* No extra space */
            width: 100%;
            content: "";}
                table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                                margin-top: 10px;

              }
          
              thead {
                font-size: 10px;
                color: #6B7280; /* Tailwind text-labelColour equivalent */
              }
          
              th {
                border-bottom: 1px solid #000;
                padding: 8px;
                text-align: left;
              }
                    td {
                padding: 6px;
                font-size: 10px;
                vertical-align: middle;
                text-align: left;
              }
                .tbody-tr{
                            background-color: #F9F9F9;
                            margin-bottom: 10px;
          
                }
                  </style>
                </head>
                <body>
               <div class="pdf-container">
                  <div class="custom-header">
                    <div class="logo-container">
                      <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                    </div>
                    <h2 class="title">Transaction History - ${investmentProductName}</h2>
                    <div class="date">${date}</div>
                  </div>
                  
            <table id="dynamic-table">
            ${tableHeader}
              ${tableBody}
          
            </table>
              
                </div> 
          
                     </body>
              </html>
            `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Transaction History-${investmentProductName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTable(false);
    setIsOpenDownloadReport(false);
  };
  useEffect(() => {
    if (isHiddenTablePortfolio == true) {
      handleDownloadPDFTablePortfolio();
    }
  }, [isHiddenTablePortfolio]);
  useEffect(() => {
    if (isHiddenTable == true) {
      handleDownloadPDFTable();
    }
  }, [isHiddenTable]);
  useEffect(() => {
    getAllPortfolioTransactions();
  }, [
    investment_id,
    showRecordsPortfolio,
    currentPagePortfolio,
    searchQueryPortfolio,
    selectedDates,
  ]);
  useEffect(() => {
    getAllDashboardPortfolioInvestors();
  }, [currentPage, showRecords, searchQuery, filterText, sortConfig]);
  return (
    <div>
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
        <div className="bg-white shadow-md rounded-md p-6 mt-4">
          <div className="flex flex-col border-b pt-2 pb-3 md:flex-row md:justify-between md:items-center">
            {/* Left-aligned Heading */}
            <h3 className="text-md font-medium mb-2 break-words">
              Caprock Model portfolio - {investmentProductName}
            </h3>

            {/* Right-aligned Information */}
            <div className="flex flex-wrap items-center space-x-2">
              <div className="flex flex-col items-center">
                <span className="text-sm font-semibold text-[#464646] leading-tight">
                  Number of
                </span>
                <span className="text-sm font-semibold text-[#464646] leading-tight">
                  Investors
                </span>
              </div>{" "}
              <span className="text-md font-semibold">|</span>
              <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                {totalInvestors}
              </span>
              <span className="text-md font-semibold">|</span>
              <div className="flex flex-col items-center">
                <span className="text-sm font-semibold text-[#464646] leading-tight">
                  Total
                </span>
                <span className="text-sm font-semibold text-[#464646] leading-tight">
                  Invested $
                </span>
              </div>{" "}
              <span className="text-sm font-semibold">|</span>
              <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                ${" "}
                {(totalInvestedAmount == null ? 0 : totalInvestedAmount)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </span>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mt-4 gap-4 flex-wrap mb-4">
            {/* Left Side: Filters & Search */}
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4 flex-wrap">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>

              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-8 border rounded-xl"
                    placeholder="Search Investors"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    <img
                      src="/search-normal.svg"
                      alt="Search Icon"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>

            {/* Right Side: Download Button */}
            <div ref={DownloadRefPortfolio} className="relative">
              <div
                className="flex items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                onClick={() =>
                  setIsOpenDownloadReportPortfolio(
                    !isOpenDownloadReportPortfolio
                  )
                }
              >
                <img
                  src="/document-download.svg"
                  alt="document-download"
                  className="mr-2"
                />
                <span>Download Report</span>
                <img
                  src="/download-small-arrow.svg"
                  alt="Dropdown"
                  className="w-2 h-2 ml-auto"
                />
              </div>
              {isOpenDownloadReportPortfolio && (
                <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                  {reportOptions.map((option) => (
                    <li
                      key={option.value}
                      className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                      onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        downloadPDFTablePortfolio(e, option);
                      }}
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="overflow-x-auto ">
            <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
              {/* Table Header */}
              <thead className="text-[#8C8C8C] text-sm">
                <tr className="border border-[#EDEDED]">
                  {investorheaders.map((header) => (
                    <th
                      key={header.label}
                      onClick={() => handleSort(header.key)}
                      className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                    >
                      <div class="flex items-center">
                        <span>{header.label}</span>
                        {header.key != "" && (
                          <img
                            src="/sort.svg"
                            alt="Icon"
                            class="w-4 h-4 ml-2"
                          />
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(3)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(4)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm font-medium text-black">
                  {investortableData.length > 0 ? (
                    investortableData.map((row, index) => (
                      <tr key={index} className="mb-2 bg-[#F9F9F9]">
                        <td
                          onClick={() => {
                            dispatch(setInvestorId(row.user_id));
                            dispatch(setInvestorName(row.investor_name));
                            dispatch(setCashReserve(row.cash_reserve));
                            let redirectState = {
                              path: "/investor-list-transactions",
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                            sessionStorage.setItem(
                              "redirectAfterLogin",
                              JSON.stringify(redirectState)
                            );
                            navigate("/investor-list-transactions", {
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            });
                          }}
                          className="underline cursor-pointer px-4 py-4 relative"
                        >
                          {row.investor_name}
                        </td>
                        <td className="px-4 py-4 relative">
                          Caprock Model portfolio - {row.portfolio_name}{" "}
                        </td>
                        <td className="px-4 py-4 relative">
                          {row.cash_reserve
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                          (2%)
                        </td>

                        <td className="px-4 py-4 relative">
                          {row.invested_amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center py-4" colSpan="7">
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
          {!isLoading && (
            <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
              {/* Entries Info Section */}
              <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                Showing {showRecords * (currentPage - 1) + 1} to{" "}
                {currentPage === totalPages || totalPages == 0
                  ? totalCount
                  : Math.max(
                      showRecords * currentPage,
                      investortableData.length
                    )}{" "}
                of {totalCount} entries
              </div>

              {/* Pagination Section */}
              <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                {/* Previous Button */}
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>

                {/* Page Buttons */}
                {Array.from({ length: Math.min(totalPages, 5) }).map(
                  (_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(totalPages - 4, currentPage - 2)
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${
                          currentPage === page
                            ? "bg-black text-white"
                            : "bg-white border border-gray-300 text-black"
                        }`}
                      >
                        {page}
                      </button>
                    );
                  }
                )}

                {/* Next Button */}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="bg-white mt-4 p-4 shadow-md rounded-md">
          <div className="flex justify-between items-center border-b border-colour-custom px-4 py-2 flex-wrap">
            {/* Left: Title */}
            <h1 className="text-xl font-medium text-black mb-2">
              Transaction History
            </h1>

            {/* Right: Download Dropdown */}
            <div
              ref={DownloadRef}
              className="relative inline-block mt-2 sm:mt-0"
            >
              <div
                className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                onClick={() => setIsOpenDownloadReport(!isOpenDownloadReport)}
              >
                <img
                  src="/document-download.svg"
                  alt="document-download"
                  className="mr-2"
                />
                <span>Download Report</span>
                <img
                  src="/download-small-arrow.svg"
                  alt="Dropdown"
                  className="w-2 h-2 ml-auto"
                />
              </div>

              {isOpenDownloadReport && (
                <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                  {reportOptions.map((option) => (
                    <li
                      key={option.value}
                      className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                      onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        downloadPDFTable(e, option);
                      }}
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="p-4">
            {/* Filters Section */}
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilterPortfolio}
                    onSelect={handleshowRecordPortfolios}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative w-full">
                    <input
                      type="text"
                      className="p-2 pl-8 w-full lg:w-auto border  rounded-xl"
                      placeholder="Search here"
                      value={searchQueryPortfolio}
                      onChange={(e) => {
                        setSearchQueryPortfolio(e.target.value);
                        setCurrentPagePortfolio(1);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {" "}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* Dropdown */}

              <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                <div
                  ref={DateCalendarRef}
                  className="flex items-center z-10 mt-4 md:mt-0 w-full space-x-4"
                >
                  <div className="relative w-full">
                    {/* Dropdown Trigger */}
                    <div
                      className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <span>{selectedRange}</span>
                      <img
                        src={
                          isDropdownOpen
                            ? "/open-dropdown.svg"
                            : "/download-small-arrow.svg"
                        }
                        alt="Dropdown Icon"
                        className="h-2 w-2 transition-transform duration-300 transform"
                      />
                    </div>

                    {/* Dropdown */}
                    {isDropdownOpen && (
                      <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-80 w-[90vw] lg:w-[650px] max-h-[400px] overflow-auto">
                        <div className="flex  flex-col md:flex-row h-full">
                          {/* Left: Quick Filters */}
                          <div className="w-full md:w-1/3 border-r p-3 h-full">
                            {quickFilters.map((filter) => (
                              <div
                                key={filter.value}
                                className={`p-2 cursor-pointer rounded ${
                                  quickFilter === filter.value
                                    ? "bg-black text-white"
                                    : "hover:bg-gray-200 text-black"
                                } transition-all duration-200 ease-in-out`}
                                onClick={() => {
                                  setCurrentPagePortfolio(1);
                                  handleQuickFilter(filter.value);
                                }}
                              >
                                {filter.label}
                              </div>
                            ))}
                          </div>

                          {/* Right: Calendar */}
                          <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                            <Flatpickr
                              key={selectedDates}
                              options={{
                                mode: "range",
                                inline: true,
                                dateFormat: "Y-m-d",
                                showMonths: 2,
                                defaultDate:
                                  selectedDates.length > 0 ? selectedDates : [],
                                shorthandCurrentMonth: true,
                                locale: {
                                  firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                },
                                onChange: (dates) => {
                                  if (
                                    quickFilter === "custom" &&
                                    dates.length === 2
                                  ) {
                                    setSelectedDates(dates);
                                  }
                                },
                              }}
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="relative w-full mt-4 md:mt-0 md:w-full">
                  {/* Dropdown Button */}
                  <button
                    onClick={() => {
                      resetAllFilters();
                    }}
                    className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                  >
                    <div className="flex items-center relative">Clear All</div>
                  </button>
                </div>
              </div>
            </div>

            {transactionTableData != null && (
              <div className="overflow-x-auto">
                <table className="w-full h-full table-fixed  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                  <thead className="text-[#8C8C8C] text-sm">
                    <tr className="border border-[#EDEDED]">
                      {headersDashboardPortfolio.map((header, index) => (
                        <th
                          key={header.label}
                          className={`
                                cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                                ${
                                  index === 0
                                    ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                                    ${
                                      index === 1 ||
                                      index === 2 ||
                                      index === 3 ||
                                      index === 4 ||
                                      index === 5 ||
                                      index === 6 ||
                                      index === 7
                                        ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                        : ""
                                    }
                                  ${
                                    index === 8
                                      ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                                      : ""
                                  }
                              `}
                        >
                          <div class="flex items-center">
                            <span>{header.label}</span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {isLoadingHistory ? (
                    <tbody className="shimmer-container-list ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(5)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(9)].map((_, colIndex) => (
                            <td key={colIndex} className="shimmer-cell-list">
                              <div className="shimmer-loader"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody className="text-sm font-medium text-black">
                      {transactionTableData.length > 0 ? (
                        transactionTableData.map((row, index) => (
                          <React.Fragment key={index}>
                            <tr
                              className={`cursor-pointer mb-2 ${
                                expandedRow === row.id
                                  ? "bg-[#EBF3F8]"
                                  : "bg-[#F9F9F9]"
                              }`}
                            >
                              <td className="px-4 py-2">
                                <div className="flex items-center space-x-2">
                                  <img
                                    src="/clock.svg"
                                    alt="Time Icon"
                                    className="h-4 w-4"
                                  />
                                  <span className="rounded-xl">
                                    {`${formatDateTransaction(row.date)}`}
                                  </span>
                                </div>
                              </td>
                              <td className="p-2">{row.reference_code}</td>
                              <td className="p-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight">
                                <span class="block">{row.account_name}</span>
                                <span class="block">{row.currency.name}</span>
                              </td>
                              <td className="p-2">
                                ${row.convert_rate.toFixed(2)}
                              </td>
                              <td className="p-2  text-[#FF5050]">
                                $
                                {row.debit
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                              <td className="p-2  text-[#62D76E]">
                                $
                                {row.credit
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                              <td className="p-2">
                                {row.balance
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>

                              <td className="px-4 py-2 relative">
                                <button
                                  ref={(el) =>
                                    (statusButtonRefs.current[`${row.id}`] = el)
                                  }
                                  disabled={
                                    row.status == "pending" ? false : true
                                  }
                                  onClick={() => handleDropdownToggle(row.id)}
                                  className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                    row.status == "pending"
                                      ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                      : ""
                                  }
                                      ${
                                        row.status == "approved"
                                          ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                          : ""
                                      }
                                            ${
                                              row.status == "completed"
                                                ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                                : ""
                                            }
                                      ${
                                        row.status == "rejected"
                                          ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                          : ""
                                      }
                                      `}
                                >
                                  <span className="mr-6">
                                    {" "}
                                    {row.status.charAt(0).toUpperCase() +
                                      row.status.slice(1)}
                                  </span>
                                  {filter == "" && row.status != "approved" && (
                                    <img
                                      src={`${
                                        openDropdown === row.id
                                          ? "/Vector.svg"
                                          : "/down-grey.svg"
                                      }`}
                                      alt="Selected"
                                      className="w-3 h-3 ml-4"
                                    />
                                  )}
                                </button>
                              </td>
                              <td
                                onClick={() => toggleRowDetails(row.id)}
                                className="text-center rounded-r"
                              >
                                {expandedRow === row.id && (
                                  <img
                                    src="/expanded-black.svg"
                                    alt="Star Icon"
                                    className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                  />
                                )}
                                {expandedRow !== row.id && (
                                  <img
                                    src="/down-grey-steps.svg"
                                    alt="Star Icon"
                                    className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                  />
                                )}
                              </td>
                            </tr>
                            {expandedRow === row.id && (
                              <tr>
                                <td
                                  colSpan={10}
                                  className="bg-[#EEF7FD] w-full"
                                >
                                  <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                    {/* Profile Details */}
                                    <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                      {/* Column 1 */}
                                      <div className="flex flex-col md:px-4  md:pt-6">
                                        <label
                                          htmlFor="refId"
                                          className="mb-1 text-xs text-[#A6A6A6]"
                                        >
                                          From
                                        </label>
                                        <Tooltip
                                          nametext={row.from_account.name}
                                          numbertext={
                                            row.from_account.unique_id
                                          }
                                          currencytext={row.currency.name}
                                        >
                                          <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                            {row.from_user
                                              ? `${row.from_user.first_name} ${row.from_user.last_name}`
                                              : ""}
                                          </span>
                                        </Tooltip>

                                        <div className="mt-4"></div>
                                      </div>

                                      {/* Column 2 */}
                                      <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                        <div className="md:border-l md:pl-4">
                                          <label
                                            htmlFor="investmentManagerFees"
                                            className="mb-1 text-xs"
                                          >
                                            <span className="text-[#A6A6A6]">
                                              Description
                                            </span>
                                          </label>
                                          <div className="text-sm">
                                            {row.description}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Column 3 */}
                                      <div className="flex flex-col md:px-0 md:pt-6">
                                        <div className="md:border-l md:pl-4">
                                          <label
                                            htmlFor="investmentManagerFees"
                                            className="mb-1 text-xs"
                                          >
                                            <span className="text-[#A6A6A6]">
                                              To
                                            </span>
                                          </label>
                                          <Tooltip
                                            nametext={row.to_account.name}
                                            numbertext={
                                              row.to_account.unique_id
                                            }
                                            currencytext={row.currency.name}
                                          >
                                            <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                              {row.to_user
                                                ? `${row.to_user.first_name} ${row.to_user.last_name}`
                                                : ""}
                                            </span>
                                          </Tooltip>
                                        </div>
                                      </div>
                                      <div className="flex flex-col md:px-0 md:pt-6">
                                        <div className="md:border-l md:pl-4">
                                          <label
                                            htmlFor="investmentManagerFees"
                                            className="mb-1 text-xs"
                                          >
                                            <span className="text-[#A6A6A6]">
                                              Ip address
                                            </span>
                                          </label>
                                          <div className="text-sm">
                                            {row.ip_address}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                    {/* Profile Details */}
                                    <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                      {/* Column 1 */}
                                      <div className="flex flex-col md:px-4 md:pt-6">
                                        <div className="mt-4">
                                          <label
                                            htmlFor="investmentType"
                                            className="mb-1 text-xs text-[#A6A6A6]"
                                          >
                                            Initiated by
                                          </label>
                                          <div className="text-sm">
                                            {row.created_by}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Column 2 */}
                                      <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                        <div className="md:border-l md:pl-4">
                                          <label
                                            htmlFor="investmentManagerFees"
                                            className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                          >
                                            Signatories
                                          </label>
                                          <div className="text-sm">
                                            <span>
                                              {row.approved_by} (
                                              {formatDateTransaction(row.date)})
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {/* Column 3 */}
                                      <div className="flex flex-col md:px-0 md:pt-6"></div>
                                      <div className="flex flex-col md:px-0 md:pt-6"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center py-4" colSpan="7">
                            No results found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            )}
            {transactionTableData != null && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing{" "}
                  {showRecordsPortfolio * (currentPagePortfolio - 1) + 1} to{" "}
                  {currentPagePortfolio === totalPagesPortfolio ||
                  totalPagesPortfolio == 0
                    ? totalCountPortfolio
                    : Math.max(
                        showRecordsPortfolio * currentPagePortfolio,
                        transactionTableData.length
                      )}{" "}
                  of {totalCountPortfolio} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPagePortfolio === 1}
                    onClick={() => setCurrentPagePortfolio((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({
                    length: Math.min(totalPagesPortfolio, 5),
                  }).map((_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(
                        totalPagesPortfolio - 4,
                        currentPagePortfolio - 2
                      )
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPagePortfolio(page)}
                        className={`px-3 py-1 rounded ${
                          currentPagePortfolio === page
                            ? "bg-black text-white"
                            : "bg-white border border-gray-300 text-black"
                        }`}
                      >
                        {page}
                      </button>
                    );
                  })}

                  {/* Next Button */}
                  <button
                    disabled={currentPagePortfolio === totalPagesPortfolio}
                    onClick={() => setCurrentPagePortfolio((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorList;
